import { Component, OnInit, HostListener, OnDestroy, Renderer2, Inject } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { TermsService } from '../../../services/terms.service'
import { SpeciesResolver } from '../species/species.resolver'
import { AuthenticationService } from 'src/app/services/authentication.service'
import { getLoggedUser, getZendeskToken } from 'src/app/_helpers/LocalStorage'
import { ChangeDetectorRef } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { UserAdmin } from 'src/app/models/UserAdmin'

@Component({
	selector: 'app-panel',
	templateUrl: './panel.component.html'
})
export class PanelComponent implements OnInit, OnDestroy {

	public currentUser: UserAdmin = getLoggedUser()
	public currentUrl: string = ''
	public roles: Array<string> = this.currentUser.roles
	public submodules: Array<string> = []
	public companyName: string = localStorage.getItem('companyName')

	public loggedCompany: boolean = false
	public openTerms: boolean = false
	public hasCheckTerms: boolean = false
	public isNavOpen: boolean = false
	public isOpen: boolean = false
	public isOpenManejo: boolean = false
	public isOpenInventor: boolean = false
	public isOpenPlanting: boolean = false
	public isOpenScheduling: boolean = false
	public isOpenCentralControl: boolean = false
	public isLoading: boolean = false

	public isGeneralAdmin: boolean = false
	public adminArbolink: boolean = false
	public companys: boolean = false
	public requesters: boolean = false
	public botaniKey: boolean = false
	public species: boolean = false
	public dashboard: boolean = false
	public realTime: boolean = false
	public adminCustomer: boolean = false
	public companyServiceProvider: boolean = false
	public regions: boolean = false
	public inventorySchedule: boolean = false
	public inventoryHistory: boolean = false
	public plantingOpportunitySchedule: boolean = false
	public plantingOpportunityHistory: boolean = false
	public appraisalSchedule: boolean = false
	public appraisalHistory: boolean = false
	public operationServiceSchedule: boolean = false
	public operationServiceHistory: boolean = false
	public publicPanel: boolean = false
	public appraisalConfiguration: boolean = false
	public managementConfiguration: boolean = false
	public operationField: boolean = false

	public subscriptionGet: any

	constructor(
		private router: Router,
		private TermsService: TermsService,
		private authenticationService: AuthenticationService,
		private cdRef: ChangeDetectorRef,
		private renderer: Renderer2,
		@Inject(DOCUMENT) private document: Document
	) {
		router.events.subscribe((_: NavigationEnd) => (this.currentUrl = _.url))
	}

	public ngOnInit(): void {
		this.insertZendeskWidget()

		SpeciesResolver.alreadyLoaded.subscribe(boolean => {
			this.isLoading = !boolean
		})

		this.checkTerms()

		if (localStorage.getItem('loggedCompany') === 'true' || this.currentUser.companies.length > 0) {
			this.loggedCompany = true
		}

		this.getAssigments()
		this.validModules()

		this.loginZendeskWidget()
	}

	public insertZendeskWidget() {
		const scriptZendesk = this.obterScriptZendesk()
		const zendeskToken = getZendeskToken()

		if (!scriptZendesk && zendeskToken) {
			const script = this.renderer.createElement('script')
			script.type = 'text/javascript'
			script.src = 'https://static.zdassets.com/ekr/snippet.js?key=3eb4fe57-1f7c-4cb0-8c17-dcef079cd25c'
			script.id = 'ze-snippet'
			this.renderer.appendChild(this.document.body, script)
		}
	}

	public checkTerms(): void {
		const acceptTerms = localStorage.getItem('acceptTerms')
		if (!acceptTerms) {
			this.openTerms = true
		}
	}

	public getAssigments() {
		if (this.currentUser.assignments.length > 0) {
			this.submodules = this.currentUser.subModules
			this.cdRef.detectChanges()
		}
	}

	public validModules() {
		const isAdmin = this.roles.includes('GENERAL_ADMIN')

		this.isGeneralAdmin = Boolean(isAdmin)
		this.adminArbolink = Boolean(isAdmin)
		this.companys = Boolean(isAdmin)
		this.requesters = Boolean(isAdmin)
		this.botaniKey = Boolean(this.roles.includes('BOTANIC') || isAdmin)
		this.species = Boolean(this.roles.includes('BOTANIC') || isAdmin)

		this.dashboard = Boolean(this.submodules.includes('DASHBOARD') || isAdmin)
		this.publicPanel = Boolean(this.submodules.includes('PUBLIC_PANEL') || isAdmin)
		this.realTime = Boolean(this.submodules.includes('REAL_TIME') || isAdmin)
		this.adminCustomer = Boolean(this.submodules.includes('USER') || isAdmin)
		this.companyServiceProvider = Boolean(this.submodules.includes('COMPANY_SERVICE_PROVIDER') || isAdmin)
		this.regions = Boolean(this.submodules.includes('REGION') || isAdmin)
		this.inventorySchedule = Boolean(this.submodules.includes('INVENTORY_SCHEDULE') || isAdmin)
		this.inventoryHistory = Boolean(this.submodules.includes('INVENTORY_HISTORY') || isAdmin)
		this.plantingOpportunitySchedule = Boolean(this.submodules.includes('PLANTING_SCHEDULE') || isAdmin)
		this.plantingOpportunityHistory = Boolean(this.submodules.includes('PLANTING_HISTORY') || isAdmin)
		this.appraisalSchedule = Boolean(this.submodules.includes('APPRAISAL_SCHEDULE') || isAdmin)
		this.appraisalHistory = Boolean(this.submodules.includes('APPRAISAL_HISTORY') || isAdmin)
		this.operationServiceSchedule = Boolean(this.submodules.includes('OPERATION_SERVICE_SCHEDULE') || isAdmin)
		this.operationServiceHistory = Boolean(this.submodules.includes('OPERATION_SERVICE_HISTORY') || isAdmin)
		this.appraisalConfiguration = Boolean(this.submodules.includes('APPRAISAL_CONFIGURATION') || isAdmin)
		this.managementConfiguration = Boolean(this.submodules.includes('MANAGEMENT_CONFIGURATION') || isAdmin)
		this.operationField = Boolean(this.submodules.includes('OPERATION_FIELD') || isAdmin)
	}

	public async loginZendeskWidget() {
		const scriptZendesk = this.obterScriptZendesk()
		const zendeskToken = getZendeskToken()

		if (scriptZendesk && zendeskToken) {

			let success: boolean = false

			for (let index = 1; index <= 3; index++) {
				await new Promise((resolve, reject) => {
					setTimeout(() => {
						try {
							(window as any).loginZendesk(zendeskToken)

							success = true
							resolve(index)
						} catch (error) {
							console.log('Retrying to connect in Zendesk!')
						}
					}, 1500)
				})

				if (success) break
			}
		}
	}

	public async submitTerms(): Promise<void> {
		localStorage.setItem('acceptTerms', 'true')
		try {
			await this.TermsService.updateTermUserApp().toPromise()
		} catch (err) {
			console.log('error http request' + err)
		}
		this.openTerms = false
	}

	public _handleNav(): boolean {
		const navState: boolean = this.isNavOpen
		if (navState === true) return false

		return true
	}

	public _handleClickNav(): boolean {
		const navState: boolean = this.isNavOpen
		if (navState === true) return (this.isNavOpen = false)

		return (this.isNavOpen = true)
	}

	public backGeneralUser(): void {
		localStorage.removeItem('loggedCompany')
		localStorage.removeItem('companyId')
		localStorage.removeItem('companyName')
		localStorage.removeItem('enableLegalFundamentation')
		localStorage.setItem('comingFromCompany', 'true')
		this.router.navigate(['/redirect'])
	}

	@HostListener('click', ['$event'])
	public onClick(event): void {
		event.stopPropagation()
		const target = event.target

		const { isOpen, isOpenManejo, isOpenInventor, isOpenPlanting, isOpenCentralControl } = this

		if (target.id === 'dropdown-central-control' && isOpenCentralControl) {
			this.isOpenCentralControl = false

			return
		}

		if (target.id === 'dropdown-panel-inventor' && isOpenInventor) {
			this.isOpenInventor = false

			return
		}

		if (target.id === 'dropdown-panel-planting' && isOpenPlanting) {
			this.isOpenPlanting = false

			return
		}

		if (target.id === 'dropdown-panel' && isOpen) {
			this.isOpen = false

			return
		}

		if (target.id === 'dropdown-panel-manejo' && isOpenManejo) {
			this.isOpenManejo = false

			return
		}

		if (target.id === 'dropdown-panel-inventor' && !isOpenInventor) {
			this.isOpenInventor = true
			this.isOpenPlanting = false
			this.isOpen = false
			this.isOpenManejo = false
			this.isOpenCentralControl = false

			return
		}

		if (target.id === 'dropdown-central-control' && !isOpenCentralControl) {
			this.isOpenCentralControl = true
			this.isOpenInventor = false
			this.isOpenPlanting = false
			this.isOpen = false
			this.isOpenManejo = false

			return
		}

		if (target.id === 'dropdown-panel-planting' && !isOpenPlanting) {
			this.isOpenInventor = false
			this.isOpenPlanting = true
			this.isOpen = false
			this.isOpenManejo = false
			this.isOpenCentralControl = false

			return
		}

		if (target.id === 'dropdown-panel' && !isOpen) {
			this.isOpenInventor = false
			this.isOpenPlanting = false
			this.isOpen = true
			this.isOpenManejo = false
			this.isOpenCentralControl = false

			return
		}

		if (target.id === 'dropdown-panel-manejo' && !isOpenManejo) {
			this.isOpenInventor = false
			this.isOpenPlanting = false
			this.isOpen = false
			this.isOpenManejo = true
			this.isOpenCentralControl = false

			return
		}

		this.isOpen = false
		this.isOpenManejo = false
		this.isOpenInventor = false
		this.isOpenCentralControl = false
		this.isOpenPlanting = false

		return
	}

	private obterScriptZendesk(): HTMLScriptElement | null {
		return this.document.getElementById('ze-snippet') as HTMLScriptElement | null
	}

	public logout(): void {
		this.authenticationService.logoff()
	}

	public ngOnDestroy(): void {
		if (this.subscriptionGet) this.subscriptionGet.unsubscribe()
	}
}
